export const CourseLearningFormats = {
    "hybrid": {
        code: "mode-hybrid",
        name: "Hybrid"
    },
    "sync": {
        code: "mode-syncOnline",
        name: "Synchronous Online"
    },
    "async": {
        code: "mode-asyncOnline",
        name: "Asynchronous Online"
    },
    "online": {
        code: "mode-syncOnline mode-asyncOnline",
        name: "Online only (Synchronous and Asynchronous)"
    },
    /*
    "inperson": {
        code: "mode-inperson",
        name: "In Person"
    },
     */
}
